import { render, staticRenderFns } from "./NotificationHistory.vue?vue&type=template&id=9c2859e0&scoped=true&"
import script from "./NotificationHistory.vue?vue&type=script&lang=js&"
export * from "./NotificationHistory.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHistory.vue?vue&type=style&index=0&id=9c2859e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2859e0",
  null
  
)

export default component.exports